import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../api/api";

export default function AuthSessionGuard({ children }) {
  const location = useLocation();
  const runningRef = useRef(false);

  
  const forceLogout = (message) => {
    console.warn("FORCE LOGOUT TRIGGERED");

    if (message) {
      alert(message);
    }

    sessionStorage.clear();
    localStorage.clear();

    // 🔥 HARD REDIRECT (cannot be blocked)
    window.location.replace("/login");
  };

  const validateSession = async () => {
  if (runningRef.current) return;
  runningRef.current = true;

  const usrId = sessionStorage.getItem("userId");
  const currentAuthToken = sessionStorage.getItem("AuthToken");

  const publicRoutes = ["/", "/login", "/forcelogin"];

  // ✅ Allow public + force-login routes
  if (publicRoutes.includes(location.pathname)) {
    runningRef.current = false;
    return;
  }

  if (!usrId || !currentAuthToken) {
    forceLogout();
    return;
  }

  try {
    const res = await api.AuthTokenActiveCheck({
      usrId,
      currentAuthToken,
    });

    const active =
      typeof res === "number"
        ? res
        : Number(res?.authTokenActive);

    if (active === 0) {
      forceLogout(
        "Your session has been terminated because your account is active on another device. Please sign in again."
      );
    }
  } catch (err) {
    console.error("Auth check failed", err);
    forceLogout();
  }

  runningRef.current = false;
};


  // Run on route change
  useEffect(() => {
    validateSession();
  }, [location.pathname]);

  // Run every 15 seconds (faster for testing)
  useEffect(() => {
    const id = setInterval(validateSession, 15000);
    return () => clearInterval(id);
  }, []);

  return children;
}
